import _ from "lodash";
import { observer } from "mobx-react";
import React from "react";
import { IApplicationFilterComponent } from "../BaseFilterComponents/IApplicationFilterComponent";
import { ApplicationFilterValuesStore } from "stores/ApplicationFilters/ApplicationFilterValuesStore";
import { useStore } from "utils/useStore";
import AcxVirtualizedSelectMultiGrouped from "components/UI/Select/AcxVirtualizedSelectMultiGrouped";
import { useRestrictedOptions } from "../BaseFilterComponents/useRestrictedOptions";
import { usePruneSelectedValuesByOptions } from "../BaseFilterComponents/usePruneSelectedValues";

export function getAgentOptionLabel(data) {
    let lbl = "";
    if (_.has(data, "fullName")) {
        if (data?.fullName !== " ") {
            lbl = data.fullName;
        } else {
            lbl = data.agentEmail;
        }
        if (data.isActive) {
            lbl = lbl + " - Active";
        } else {
            lbl = lbl + " - Inactive";
        }
    } else {
        lbl = data.label;
    }
    return lbl;
}

export const AgentsFilter = observer(function (
    props: IApplicationFilterComponent,
) {
    const filterValuesStore = useStore(ApplicationFilterValuesStore);
    const isAgentsLoading = filterValuesStore.getTaskLoading(
        ApplicationFilterValuesStore.Tasks.LOAD_AGENTS,
    );
    const { availableOptions: availableAgents } = useRestrictedOptions({
        options: filterValuesStore.agents,
        getOptionValue: (agent) => agent.id,
        optionRestriction: props.optionRestriction,
        restrictedValues: props.restrictedValues,
        excludeEmptyValues: true,
    });

    usePruneSelectedValuesByOptions({
        selectedValues: props.store.agentIds,
        setSelectedValues: (agentIds) => props.store.setAgentIds(agentIds),
        availableOptions: availableAgents,
        getSelectedValue: (agentId) => agentId,
        getOptionValue: (agent) => agent.id,
        enabled: !isAgentsLoading,
    });

    return (
        <AcxVirtualizedSelectMultiGrouped
            id={"agent-filter-selector"}
            defaultSelectedIds={props.store.agentIds}
            onApply={(agentIds: string[]) => {
                props.store.setAgentIds(agentIds);
            }}
            options={availableAgents}
            isLoading={isAgentsLoading}
            itemName="Agent"
            labelField="fullName"
        />
    );
});
